import { PUBLIC_LANGUAGES, publicPage } from "./public-content.js";
import { legalPage } from "./legal-content.js";
export const SITE_ORIGIN = "https://www.dayx.uz";
export const SITE_IMAGE = SITE_ORIGIN + "/icon-512.png";
export const AUTH_ROUTES = [
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/verify-email",
];
export const WORKSPACE_ROUTES = [
  "today",
  "weekly",
  "table",
  "exams",
  "all",
  "manage",
  "pomodoro",
  "settings",
  "owner",
];
export const SITE_COPY = {
  uz: {
    title: "DayX — Kunlik reja va natijalar kuzatuvi",
    description:
      "DayX bilan kunlik va haftalik reja tuzing, bajarilgan ishlarni kuzating va Pomodoro taymerida diqqatni jamlang. O‘zbek, ingliz va rus tillarida.",
    locale: "uz_UZ",
  },
  en: {
    title: "DayX — Daily planner, plan tracker and focus",
    description:
      "Your daily system for daily plans, weekly planning and progress tracking. Use the DayX daily planner, plan tracker and Pomodoro timer in one workspace.",
    locale: "en_US",
  },
  ru: {
    title: "DayX — Планировщик дня и трекер планов",
    description:
      "Планы на день и неделю, трекер задач и таймер Помодоро в одном пространстве DayX. Планируйте работу, отмечайте выполнение и отслеживайте прогресс.",
    locale: "ru_RU",
  },
};
export function siteStructuredData(language = "uz") {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": SITE_ORIGIN + "/#website",
        name: "DayX",
        alternateName: ["dayx.uz", "DayX.uz", "DayX planner"],
        url: SITE_ORIGIN + "/",
        description: SITE_COPY[language].description,
        inLanguage: ["uz", "en", "ru"],
      },
      {
        "@type": "WebApplication",
        "@id": SITE_ORIGIN + "/#application",
        name: "DayX",
        url: SITE_ORIGIN + "/",
        image: SITE_IMAGE,
        description: SITE_COPY[language].description,
        applicationCategory: "ProductivityApplication",
        operatingSystem: "Any",
        inLanguage: ["uz", "en", "ru"],
        browserRequirements: "Requires a web browser with JavaScript enabled.",
      },
    ],
  };
}
export function seoHead(path = "/", verification = "") {
  const home = path === "/";
  const guide = publicPage(path);
  const legal = legalPage(path);
  const page = guide || legal;
  const copy = page
    ? { ...page.copy, locale: SITE_COPY[page.language].locale }
    : SITE_COPY.uz;
  const indexable = home || !!page;
  const pageId = guide?.topic.id || legal?.id;
  const url = SITE_ORIGIN + path;
  const token = /^[A-Za-z0-9_-]{1,256}$/.test(verification) ? verification : "";
  return `<!-- dayx:seo -->
    <title>${copy.title}</title>
    <meta name="description" content="${copy.description}">
    <meta name="robots" content="${indexable ? "index,follow,max-image-preview:large" : "noindex,follow"}">
    <link rel="canonical" href="${url}">
    ${page ? [...PUBLIC_LANGUAGES, "x-default"].map((language) => `<link rel="alternate" hreflang="${language}" href="${SITE_ORIGIN}/${language === "x-default" ? "uz" : language}/${pageId}">`).join("\n    ") : ""}
    <meta property="og:type" content="website">
    <meta property="og:site_name" content="DayX">
    <meta name="application-name" content="DayX">
    <meta property="og:image" content="${SITE_IMAGE}">
    <meta property="og:image:width" content="512">
    <meta property="og:image:height" content="512">
    <meta property="og:image:alt" content="DayX">
    <meta property="og:locale" content="${copy.locale}">
    <meta property="og:title" content="${copy.title}">
    <meta property="og:description" content="${copy.description}">
    <meta property="og:url" content="${url}">
    <meta name="twitter:card" content="summary">
    <meta name="twitter:image" content="${SITE_IMAGE}">
    <meta name="twitter:image:alt" content="DayX">
    <meta name="twitter:title" content="${copy.title}">
    <meta name="twitter:description" content="${copy.description}">
    ${token ? `<meta name="google-site-verification" content="${token}">` : ""}
    ${home ? `<script type="application/ld+json" id="dayxStructuredData">${JSON.stringify(siteStructuredData()).replace(/</g, "\\u003c")}</script>` : ""}
    ${
      guide
        ? `<script type="application/ld+json">${JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": url + "#page",
                url,
                name: copy.title,
                description: copy.description,
                inLanguage: guide.language,
                isPartOf: { "@id": SITE_ORIGIN + "/#website" },
              },
              {
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "DayX",
                    item: SITE_ORIGIN + "/",
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: guide.topic.term,
                    item: url,
                  },
                ],
              },
            ],
          }).replace(/</g, "\\u003c")}</script>`
        : ""
    }
    <!-- /dayx:seo -->`;
}
export function withPageSEO(html, path = "/", verification = "") {
  const presentation =
    path === "/" || publicPage(path) || legalPage(path)
      ? "home"
      : AUTH_ROUTES.includes(path)
        ? "auth"
        : "workspace";
  return html
    .replace(
      /<html lang="[^"]*"/,
      `<html lang="${(publicPage(path) || legalPage(path))?.language || "uz"}"`,
    )
    .replace(
      /<!-- dayx:seo -->[\s\S]*?<!-- \/dayx:seo -->/,
      seoHead(path, verification),
    )
    .replace(/data-presentation="home"/, `data-presentation="${presentation}"`);
}
